const module = { name: 'theater/showtimesNoLocation/showtimesNoLocation.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile } } } = Fandango_context;


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as theater_shared_tdpLocationHelper_getLocationSlugged } from 'swug-fdRequire-call:theater/shared/tdpLocationHelper';

const { getLocationSlugged } = theater_shared_tdpLocationHelper_getLocationSlugged;


import { default as shared_utils_urlHelpers_generateTspLink } from 'swug-fdRequire-call:shared/utils/urlHelpers';

const { generateTspLink } = shared_utils_urlHelpers_generateTspLink;
function run() {
    checkDependencies(module.name, debugLog);
    const location = getLocationSlugged();
    if (location) {
        const params = Object.fromEntries(new URLSearchParams(window.location.search).entries());
        if (isMobile || params.filter !== 'my-theaters') {
            delete params.filter;
        }
        window.location = generateTspLink(location, params);
    }
}
run();
export default module.exports;